import client from "./lib/request-manager";
import ImageServiceFactory from "./s3.service";

const ImageService = ImageServiceFactory(client);

export default {
  imageS3Service: new ImageService(),
};
